import { render, staticRenderFns } from "./ContainerModalComponent.vue?vue&type=template&id=68aed37e&scoped=true"
import script from "./ContainerModalComponent.vue?vue&type=script&lang=js"
export * from "./ContainerModalComponent.vue?vue&type=script&lang=js"
import style0 from "./ContainerModalComponent.vue?vue&type=style&index=0&id=68aed37e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68aed37e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/graphileon/graphileon/release/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68aed37e')) {
      api.createRecord('68aed37e', component.options)
    } else {
      api.reload('68aed37e', component.options)
    }
    module.hot.accept("./ContainerModalComponent.vue?vue&type=template&id=68aed37e&scoped=true", function () {
      api.rerender('68aed37e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "apps/default/containers/ContainerModalComponent.vue"
export default component.exports